import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateTask as UpdateTaskMutation,
    UpdateTaskVariables,
    TaskUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_TASK from '../mutations/update-task.graphql';

interface UpdateTaskOptions {
    refetchQueries: any[];
}

export const useUpdateTask = (
    options?: UpdateTaskOptions
): {
    updateTask: (arg1: TaskUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateTask, {loading, error}] = useMutation<UpdateTaskMutation, UpdateTaskVariables>(
        UPDATE_TASK
    );

    return {
        updateTask: (input: TaskUpdateInput) => {
            return updateTask({
                variables: {input},
                refetchQueries: options?.refetchQueries,
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
